import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";

// Components
import Spinner from "../../Spinners/Spinner";
import ModalFormNote from "../../modals/ModalFormNote";
import ModalDelete from "../../modals/ModalDelete";

// Utils
import { ChatContext } from "../../../context/chat/ChatContext";
import { useGetDta } from "../../../hooks/useGetDta";

/**
 * Pestaña de notas de chat
 *
 * @returns {JSX.Element} Componente de react
 */
const NotesTab = () => {
  const [show, setShow] = useState(false); // Modal de formulario
  const [showDelete, setShowDelete] = useState(false); // Modal de eliminación
  const [info, setInfo] = useState({ path: "", action: "", id: "" }); // Información de formulario

  // Contexto de chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Obtener notas del chat
  const { loading, data, getInfo } = useGetDta(
    `respuestas/notas`,
    {
      id_user: activeChat.id_user || activeChat.id,
    },
    "POST"
  );

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner />
      </div>
    );

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h4>Notas</h4>
        {data.length < 1 ? (
          <Button
            variant="success"
            onClick={() => {
              setInfo({
                path: `respuestas/nota`,
                action: "POST",
                id: activeChat.id_user,
              });
              setShow(true);
            }}
          >
            <i className="mdi mdi-plus fw-bolder" /> Nueva
          </Button>
        ) : null}
      </div>
      <div className="d-flex flex-column">
        {data.length === 0 && (
          <p className="text-center mt-3">No hay notas registradas</p>
        )}

        {data.map((note, index) => (
          <div
            key={index}
            className="d-flex justify-content-between align-items-center border-bottom py-2"
          >
            <p
              className="m-0"
              style={{
                maxWidth: "75%",
                content: "justify",
              }}
            >
              {note.nota}
            </p>

            <div>
              <i
                className="mdi mdi-pencil text-primary font-18"
                onClick={() => {
                  setInfo({
                    path: `respuestas/nota`,
                    action: "PUT",
                    id: note.id,
                  });
                  setShow(true);
                }}
              />

              <i
                className="mdi mdi-delete text-danger font-18 ms-1 me-2"
                onClick={() => {
                  setInfo({
                    path: `respuestas/nota`,
                    action: "DELETE",
                    id: note.id,
                    type: "Nota",
                    element: note.nota,
                  });
                  setShowDelete(true);
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Modal de formulario */}
      <ModalFormNote
        show={show}
        handleClose={() => {
          setShow(false);
        }}
        info={info}
        callBack={getInfo}
      />

      {/* Modal de eliminación */}
      <ModalDelete
        show={showDelete}
        handleClose={() => {
          setShowDelete(false);
        }}
        info={info}
        callBack={getInfo}
      />
    </>
  );
};

export default NotesTab;
